module.exports = __webpack_public_path__ + "img/ch-food-consumption.1920f81a.jpg";